module.exports = __webpack_public_path__ + "static/media/travisgo_bg_businesspartner.95f79d23.webp";